/**
 * Gesture threshold constants for touch interactions
 * Following Material Design and mobile UX best practices
 */

export const GESTURE_THRESHOLDS = {
  pullToRefresh: {
    trigger: 80, // px to trigger refresh
    maxPull: 120, // px maximum pull distance
  },
  longPress: {
    duration: 500, // ms to trigger
    moveCancel: 10, // px movement to cancel
  },
  swipe: {
    minVelocity: 0.3, // px/ms
    minDistance: 50, // px to register swipe
    maxVertical: 30, // px vertical drift allowed
  },
  undo: {
    timeout: 5000, // ms before auto-execute
  },
} as const

export type GestureThresholds = typeof GESTURE_THRESHOLDS
